import React, { useEffect, useState } from 'react';
import { Input, Select, Button, DatePicker, ConfigProvider } from 'antd';
import styles from './assessment.module.scss';
import { useNavigate } from 'react-router-dom';
import zhCN from 'antd/es/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import {
  Input as MobileInput,
  Button as MobileButton,
  DatePicker as MobileDatePicker,
  Picker as MobilePicker,
} from 'antd-mobile';
const { RangePicker } = DatePicker;

const Assessment = ({ onQuerySubmit }) => {
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate(); // 初始化 useNavigate
  const [formData, setFormData] = useState({
    attestationNumber: '', //证书编号
    attestationName: '', //产品名称
    attestationModel: '', //型号
    certificationBasis: '', //认证依据
    status: -1, //状态
    memberName: '', //组织名称
    dateRange: [null, null],
    attestationType: 3,
    displayStatus: 1
  });
  const [mobileDatasTitles, setMobileDatasTitles] = useState('开始时间');
  const [outMobileDatasTitles, setOutMobileDatasTitles] = useState('结束时间');
  const handleInputChange = (e, key) => {
    setFormData(prevData => ({
      ...prevData,
      [key]: e,
    }));
  };

  const handleSelectChange = (value, key) => {
    setFormData(prevData => ({
      ...prevData,
      [key]: value,
    }));
  };

  const handleDateRangeChange = (dates) => {
    setFormData(prevData => ({
      ...prevData,
      dateRange: dates,
    }));
  };
  useEffect(() => {
    const media = window.matchMedia('(max-width: 768px)');
    const handler = (e) => setIsMobile(e.matches);
    setIsMobile(media.matches);
    media.addEventListener('change', handler);
    return () => media.removeEventListener('change', handler);
  },);
  const handleSearch = () => {
    // 构造查询参数
    const { attestationType, attestationNumber, attestationName, attestationModel, certificationBasis, status, memberName, dateRange } = formData;
    const queryParams = new URLSearchParams({
      attestationNumber,
      attestationName,
      attestationModel,
      certificationBasis,
      status: status,
      memberName,
      startDate: dateRange[0] ? dateRange[0].format('YYYY-MM-DD HH:mm:ss') : '',
      endDate: dateRange[1] ? dateRange[1].format('YYYY-MM-DD HH:mm:ss') : '',
      attestationType
    });
    // 跳转到目标路由，传递查询参数
    navigate(`/home2?${queryParams.toString()}`);

  };
  const handleSearch2 = () => {
    // 构造查询参数
    const { attestationType, attestationNumber, attestationName, attestationModel, certificationBasis, status, memberName, dateRange } = formData;
    const queryParams = new URLSearchParams({
      attestationNumber,
      attestationName,
      attestationModel,
      certificationBasis,
      status: status,
      memberName,
      startDate: mobileDatasTitles == '开始时间' ? '' : mobileDatasTitles + ' 00:00:00',
      endDate: outMobileDatasTitles == '结束时间' ? '' : mobileDatasTitles + ' 00:00:00',
      attestationType
    });
    // 跳转到目标路由，传递查询参数
    navigate(`/home2?${queryParams.toString()}`);

  };

  const productNameList = [
    { value: -1, label: '全部' },
    { value: 0, label: '有效' },
    { value: 1, label: '暂停' },
    { value: 2, label: '撤销' },
    { value: 3, label: '注销' },
  ];
  const basicColumns = [
    [
      { value: -1, label: '全部' },
      { value: 0, label: '有效' },
      { value: 1, label: '暂停' },
      { value: 2, label: '撤销' },
      { value: 3, label: '注销' },
    ]
  ];
  const renderInput = (label, placeholder, value, onChange, key) => (
    <div>
      <div className={styles.seachScreenName}>{label}</div>
      <Input
        className={styles.customInput}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value, key)}
      />
    </div >
  );
  const renderMobileInput = (label, placeholder, value, onChange, key) => (
    <div className={`${styles.MobileItems}`}>
      <div className={styles.MobileSeachScreenName}>{label}</div>
      <div className={styles.MobileCustomInput}>
        <MobileInput
          className={styles.MobileInput}
          placeholder={placeholder}
          value={value}
          style={{
            '--font-size': '12px', // 示例：自定义字号
          }}
          onChange={(e) => onChange(e, key)}
        />
      </div>
    </div>
  );

  const renderSelect = (label, value, onChange, key, options) => (
    <div className={styles.itemTow}>
      <div className={styles.seachScreenName}>{label}</div>
      <Select
        showSearch
        style={{ backgroundColor: '#F4F5F7' }}
        className={styles.customSelect}
        placeholder="请选择"
        optionFilterProp="label"
        value={value}
        onChange={(value) => onChange(value, key)}
        options={options}
      />
    </div>
  );
  const [visible, setVisible] = useState(false)
  const [mobileStatusTitles, setMobileStatusTitles] = useState('全部');
  const renderMobileSelect = (label, value) => {
    const safeValue = Array.isArray(value) ? value : (value != null ? [value] : []);

    return (
      <div className={styles.itemTow}>
        <div className={styles.MobileSeachScreenName}>{label}</div>
        <Button className={styles.MobileButtonSty} onClick={() => setVisible(true)}>{mobileStatusTitles}</Button>
        <MobilePicker
          columns={basicColumns}
          visible={visible}
          onClose={() => setVisible(false)}
          value={safeValue}
          onConfirm={(v) => {
            console.log('Selected values:', v);
            var labore = v[0]
            for (const key in productNameList) {
              if (productNameList[key].value === labore) {
                console.log(productNameList[key].label);
                setMobileStatusTitles(productNameList[key].label)
              }
            }
            setFormData({
              ...formData,
              status: v
            });
          }}
        />
      </div>
    );
  };
  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    // 使用 toLocaleString 进行格式化
    const formattedDate = d.toLocaleString('zh-CN', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',

    });
    // 移除逗号并替换斜杠为短横线
    return formattedDate.replace(',', '').replace(/\//g, '-').replace(' ', ' ');
  };
  const BasicDemo = () => {
    const [startVisible, setStartVisible] = useState(false);
    const [endVisible, setEndVisible] = useState(false);
    const [selectedStartDate, setSelectedStartDate] = useState(new Date()); // 存储选择的开始时间
    return (
      <div className={styles.seachScreenBasicDemo}>
        <div className={styles.MobileSeachScreenName}>发证日期</div>
        <div className={styles.MobileDatePicker}>
          <MobileButton
            className={styles.MobileButtona}
            onClick={() => setStartVisible(true)}
          >
            {mobileDatasTitles}
          </MobileButton>

          <MobileDatePicker
            title="开始时间选择"
            visible={startVisible}
            format="YYYY-MM-DD HH:mm"
            onClose={() => setStartVisible(false)}

            onConfirm={(val) => {
              const formattedDate = formatDate(val);
              setMobileDatasTitles(formattedDate || '开始时间');
              setSelectedStartDate(new Date(val));
              console.log('SelectedStartDate', new Date(val));

              setStartVisible(false);
            }}
            onCancel={() => setStartVisible(false)}
          />

          {/* 分隔符 */}
          <div className={styles.MobileButton}> 至 </div>

          {/* 结束时间选择器 */}
          <MobileButton

            className={styles.MobileButtona}
            onClick={() => setEndVisible(true)}
          >
            {outMobileDatasTitles}
          </MobileButton>

          <MobileDatePicker
            title="结束时间选择"
            visible={endVisible}
            format="YYYY-MM-DD HH:mm"
            onClose={() => setEndVisible(false)}
            min={selectedStartDate}
            onConfirm={(val) => {
              const formattedDate = formatDate(val);
              console.log('结束时间:', formattedDate);
              setOutMobileDatasTitles(formattedDate || '结束时间');
              setEndVisible(false);
            }}
            onCancel={() => setEndVisible(false)}
          />
        </div>
      </div>
    )
  }
  if (isMobile) {
    return (
      <ConfigProvider locale={zhCN}> {/* 使用 ConfigProvider 来包裹整个组件 */}
        <div className={styles.ComponentOne}>
          <div className={styles.seachTitle}>评估评价证书查询</div>
          <div className={styles.seachMobileContents}>
            <div className={styles.seachMobileClass}>
              {renderMobileInput('证书编号', '请输入证书编号', formData.attestationNumber, handleInputChange, 'attestationNumber')}
              {renderMobileInput('获证组织名称', '请输入获证组织名称', formData.memberName, handleInputChange, 'memberName', styles.itemTow)}
              {renderMobileInput('评估评价依据', '请输入评估评价依据', formData.certificationBasis, handleInputChange, 'certificationBasis')}
              {renderMobileSelect('证书状态', formData.status, handleSelectChange, 'status', productNameList)}
              <BasicDemo />
              <MobileButton
                style={{
                  background: '#15356A',
                  width: '100%',
                  color: '#fff',
                }}
                className={styles.seachBtn}
                type="primary"
                onClick={handleSearch2}
              >
                查询
              </MobileButton>
            </div>
          </div>
        </div>
      </ConfigProvider>
    )
  } else {
    return (
      <ConfigProvider locale={zhCN}> {/* 使用 ConfigProvider 来包裹整个组件 */}
        <div className={styles.ComponentOne}>
          <div className={styles.seachTitle}>评估评价证书查询</div>
          <div className={styles.seachContents}>
            <div className={styles.seachScreen}>
              {renderInput('证书编号', '请输入证书编号', formData.attestationNumber, handleInputChange, 'attestationNumber')}
              {renderInput('获证组织名称', '请输入获证组织名称', formData.memberName, handleInputChange, 'memberName', styles.itemTow)}
              {renderInput('评估评价依据', '请输入评估评价依据', formData.certificationBasis, handleInputChange, 'certificationBasis')}
            </div>
            <div className={styles.seachScreen}>
              {renderSelect('证书状态', formData.status, handleSelectChange, 'status', productNameList)}
            </div>
            <div className={styles.seachScreen}>
              <div className={styles.item}>
                <div className={styles.seachScreenName}>发证日期</div>

                <RangePicker
                  className={styles.RangePickerName}
                  placeholder={['请选择起始日期', '请选择结束日期']}
                  size="middle"
                  value={formData.dateRange}
                  onChange={handleDateRangeChange}
                />
              </div>
              <div className={styles.itemAS}>
                <Button

                  className={styles.seachBtn}
                  type="primary"
                  size="Large"
                  onClick={handleSearch}
                >
                  查询
                </Button>
              </div>
            </div>
          </div>
        </div>
      </ConfigProvider >
    );
  }
};

export default Assessment;
